
import React, { ReactNode } from 'react';
import { SobrietyProvider as BaseSobrietyProvider } from './SobrietyContext';

interface SobrietyProviderProps {
  children: ReactNode;
}

// Enhanced SobrietyProvider that wraps the base SobrietyContext provider
export const SobrietyProvider: React.FC<SobrietyProviderProps> = ({ children }) => {
  return (
    <BaseSobrietyProvider>
      {children}
    </BaseSobrietyProvider>
  );
};

// Re-export the existing hook for easy access
export { useSobriety } from './SobrietyContext';

export default SobrietyProvider;
